import React from 'react';
import { Icon } from '../../../../Components/Icons/Icons';

export const HeartratePercentageIconFactory = ({ percentage }) => {
    switch (true) {
        case percentage === null:
            return <Icon.HeartratePercentWhite />;
        case percentage <= 60:
            return <Icon.HeartratePercentPurple />;
        case percentage <= 70:
            return <Icon.HeartratePercentBlue />;
        case percentage <= 80:
            return <Icon.HeartratePercentGreen />;
        case percentage <= 90:
            return <Icon.HeartratePercentOrange />;
        case percentage <= 100:
            return <Icon.HeartratePercentRed />;
        default:
            return <Icon.HeartratePercentWhite />;
    }
};

export const CaloriesIconFactory = ({ percentage }) => {
    switch (true) {
        case percentage === null:
            return <Icon.CaloriesWhite />;
        case percentage <= 60:
            return <Icon.CaloriesPurple />;
        case percentage <= 70:
            return <Icon.CaloriesBlue />;
        case percentage <= 80:
            return <Icon.CaloriesGreen />;
        case percentage <= 90:
            return <Icon.CaloriesOrange />;
        case percentage <= 100:
            return <Icon.CaloriesRed />;
        default:
            return <Icon.CaloriesWhite />;
    }
};

export const HeartrateIconFactory = ({ percentage }) => {
    switch (true) {
        case percentage === null:
            return <Icon.HeartrateWhite />;
        case percentage <= 60:
            return <Icon.HeartratePurple />;
        case percentage <= 70:
            return <Icon.HeartrateBlue />;
        case percentage <= 80:
            return <Icon.HeartrateGreen />;
        case percentage <= 90:
            return <Icon.HeartrateOrange />;
        case percentage <= 100:
            return <Icon.HeartrateRed />;
        default:
            return <Icon.HeartrateWhite />;
    }
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/LiveDisplay/Content/ImagesFactory.js